import { Channel } from '@/features/orders/constants/app'

export const channels = {
    [Channel.Foodora]: 'Foodora',
    [Channel.Kiosk]: 'Kiosek',
    [Channel.Menuboard]: 'Menuboard',
    [Channel.QR]: 'QR',
    [Channel.Web]: 'E-shop',
    [Channel.Wolt]: 'Wolt',
    [Channel.Pos]: 'Pokladna',
    [Channel.Phone]: 'Telefon',
    [Channel.Tab]: 'Otevřený účet',
}
